import { render } from "./ModalProducto.vue?vue&type=template&id=0ff68c0e&scoped=true"
import script from "./ModalProducto.vue?vue&type=script&lang=js"
export * from "./ModalProducto.vue?vue&type=script&lang=js"

import "./ModalProducto.vue?vue&type=style&index=0&id=0ff68c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ff68c0e"]])

export default __exports__